/**
 * done
 */
import React from 'react';
import { wrapReactionHook } from "../../hooks";
import { useDictMap } from "../../hooks";
import { isEmpty } from '@formily/shared';
import { useField } from '@formily/react';
export var DictText = wrapReactionHook(function (props) {
  var defaultRender = function defaultRender(label, value, index, map, isHaveLabel) {
    if (label == null) {
      return /*#__PURE__*/React.createElement("span", {
        key: index
      }, placeholder);
    }
    return /*#__PURE__*/React.createElement("span", {
      key: index
    }, String(label));
  };
  var dictType = props.dictType,
    dictMap = props.dictMap,
    value = props.value,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$childrenLoadLe = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe === void 0 ? 5 : _props$childrenLoadLe,
    _props$delimiter = props.delimiter,
    delimiter = _props$delimiter === void 0 ? '、' : _props$delimiter,
    addonBefore = props.addonBefore,
    addonAfter = props.addonAfter,
    _props$render = props.render,
    render = _props$render === void 0 ? defaultRender : _props$render,
    placeholder = props.placeholder,
    url = props.url,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    autoRemoveDict = props.autoRemoveDict,
    enums = props.enums,
    getText = props.getText;
  var field = useField();
  var fieldEnums = field && field.dataSource;
  var map = useDictMap(dictType, {
    level: level,
    childrenLoadLevel: childrenLoadLevel,
    url: url,
    autoRemoveDict: autoRemoveDict,
    params: params,
    dictMap: dictMap,
    enums: enums || fieldEnums
  });
  if (isEmpty(value)) {
    return '-';
  }
  var getDictValue = function getDictValue(v) {
    if (v != null && map[v]) {
      return map[v].label;
    }
    return v;
  };
  var isHaveLabel = function isHaveLabel(v) {
    var _map$v, _map$v2, _map$v3;
    return !!((_map$v = map[v]) !== null && _map$v !== void 0 && _map$v.label) || ((_map$v2 = map[v]) === null || _map$v2 === void 0 ? void 0 : _map$v2.label) === '' || ((_map$v3 = map[v]) === null || _map$v3 === void 0 ? void 0 : _map$v3.label) === '0';
  };
  var renderList = [];
  var textList = [];
  if (Array.isArray(value)) {
    if (value.length) {
      value.forEach(function (v, idx) {
        var label = getDictValue(v);
        renderList.push(render(label, v, idx, map, isHaveLabel(v)));
        textList.push(label);
        renderList.push(delimiter);
      });
      renderList.pop();
    } else {
      renderList.push( /*#__PURE__*/React.createElement("span", null, placeholder));
    }
  } else {
    var _label = getDictValue(value);
    var elem = render(_label, value, 0, map, isHaveLabel(value));
    renderList.push(elem);
    textList.push(_label);
  }
  getText && getText(textList.join('\n'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, addonBefore, renderList, addonAfter);
});